import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './AboutHeroSection.scss';
import aboutHeroImage from '../../../../assets/images/about/about-hero.jpg';

const AboutHeroSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const scaleReveal = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, scale: 0.98 },
              whileInView: { opacity: 1, scale: 1 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="about-hero">
            <motion.img
                {...scaleReveal}
                src={aboutHeroImage}
                alt={t('alt_about_us')}
                className="about-hero__image"
            />
            <div className="about-hero__overlay"></div>
        </section>
    );
};

export default AboutHeroSection;